import React, { memo } from "react";

import { getLocalization } from "@utilities";

import { SearchListLocalization, SearchResultType } from "../types";

const ListItem: React.FC<SearchResultType & { apiLocalization: SearchListLocalization }> = ({
  title,
  url,
  target,
  breadcrumb,
  mime,
  extension,
  apiLocalization,
  showBreadcrumbs
}) => {
  if (!title || !url) return null;

  const textDocToDownload = getLocalization(apiLocalization, "search/DocToDownload");

  return (
    <li className="block border-b border-grey-30 first:border-t">
      <a className="group block break-words py-6 px-4" href={url} target={target}>
        <div className="mb-[0.375rem] font-semibold leading-7 underline media-group-hover:text-red-corporate media-group-hover:decoration-red-corporate sm:mb-2 sm:duration-300">
          {title}
        </div>
        {(showBreadcrumbs && breadcrumb) && <p className="text-xs font-normal text-grey-180">{breadcrumb}</p>}
        {mime && (
          <div className="flex">
            <p className="mr-2 text-xs font-normal text-grey-180">{textDocToDownload}</p>
            <div className="flex items-center rounded-lg bg-white py-0 px-3 text-2xs font-semibold shadow-tab">
              {extension.toUpperCase()}
            </div>
          </div>
        )}
      </a>
    </li>
  );
};

export default memo(ListItem);
